import React, { forwardRef, Fragment, useState } from "react";
import { Form } from "antd";
import MaskedInput from "react-text-mask";
import PropTypes from "prop-types";

const isValidHour = (value, includeSeconds = false, allowMoreThan24 = true) => {
  if (!value) return true;

  const regex = includeSeconds
    ? allowMoreThan24 ? /^\d+:([0-5]\d):([0-5]\d)$/ : /^([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/
    : allowMoreThan24 ? /^\d+:([0-5]\d)$/ : /^([01]\d|2[0-3]):([0-5]\d)$/;

  return regex.test(value);
};

const HourPickerWithMask = forwardRef((props, ref) => {
  const {
    label,
    name,
    required,
    onKeyUp,
    form_,
    disabled,
    placeholder,
    seconds,
    customRoles,
    threeDigitMask,
    onValidChange,
    allowMoreThan24,
    ...rest
  } = props;

  const [hasError, setHasError] = useState(false);

  const mask = threeDigitMask
    ? [/\d/, /\d/, /\d/, ":", /\d/, /\d/]
    : seconds
      ? [/\d/, /\d/, ":", /\d/, /\d/, ":", /\d/, /\d/]
      : [/\d/, /\d/, ":", /\d/, /\d/];

  const handleBlur = (e) => {
    const value = e.target.value;
    const valid = isValidHour(value, seconds, allowMoreThan24);

    setHasError(!valid);

    if (props.onValidChange) {
      props.onValidChange(valid);
    }
  };

  const errorMessage = seconds
    ? "Informe um horário válido no formato HH:mm:ss."
    : "Informe um horário válido no formato HH:mm.";

  const inputElement = (
    <MaskedInput
      ref={ref}
      className={`ant-input ${hasError ? "ant-input-status-error" : ""}`}
      placeholder={placeholder}
      onKeyUp={onKeyUp}
      mask={mask}
      disabled={disabled}
      onBlur={handleBlur}
      {...rest}
    />
  );

  return (
    <Fragment>
      {form_ ? (
        <Form.Item
          name={name}
          label={label}
          rules={[
            { required, message: "Campo obrigatório." },
            {
              validator: (_, value) =>
                isValidHour(value, seconds, allowMoreThan24)
                  ? Promise.resolve()
                  : Promise.reject(new Error(errorMessage)),
            },
            ...customRoles,
          ]}
        >
          {inputElement}
        </Form.Item>
      ) : (
        inputElement
      )}
    </Fragment>
  );
});

HourPickerWithMask.defaultProps = {
  label: "",
  name: "",
  required: false,
  onKeyUp: null,
  form_: true,
  customRoles: [],
  disabled: false,
  placeholder: "",
  seconds: false,
  threeDigitMask: false,
};

HourPickerWithMask.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  required: PropTypes.bool,
  onKeyUp: PropTypes.func,
  form_: PropTypes.bool,
  customRoles: PropTypes.any,
  disabled: PropTypes.bool,
  placeholder: PropTypes.string,
  seconds: PropTypes.bool,
  threeDigitMask: PropTypes.bool,
};

export default HourPickerWithMask;
